import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import 'material-icons/iconfont/material-icons.css'
import 'babel-polyfill'

import './assets/css/custom.css'

import App from './App.vue'

import router from './router'
import store from './store'

import { setSession } from './helpers/session'
import constants from './config/constants'

import './components'

Vue.use(Vuetify, {
	theme:  {
	  primary: "#039BE5",
	  secondary: "#0288D1",
	  accent: "#0277BD",
	  error: "#E53935",
	  warning: "#FFA000",
	  info: "#2196F3",
	  success: "#4caf50"
	}
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data () {
    return {
      topbarBg: "primary",//blue-grey, deep-purple, indigo, cyan, teal, deep-orange
      snackbar: {
      	timeout: 2000,
      	status: false,
      	message: '',
        color: ''
      }
    }
  }
})

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
    store.commit('setLoading', true)
    // Do something before request is sent
    return config;
  }, function (error) {
    console.log("axios request error => ", error)
    // Do something with request error
    store.commit('setLoading', false)
    return Promise.reject(error);
  });

// Add a response interceptor
Vue.axios.interceptors.response.use(function (response) {
    store.commit('setLoading', false)
    // Do something with response data
    if (response.headers['x-refresh-token'] && response.headers['x-token']) {
      let token = response.headers['x-token']
      let refreshToken = response.headers['x-refresh-token']
      setSession('sessionId', token)
      setSession('refreshToken', refreshToken)
      Vue.axios.defaults.headers.common[constants.auth_header_key] = "Bearer " + token //Authorization
      Vue.axios.defaults.headers.common[constants.refresh_token_key] = refreshToken
    }
    return response;
  }, function (error, response) {
    console.log("axios response error => ", error)
    store.commit('notify', {
      message: 'Some error occured!',
      color: 'error'
    })

    store.commit('setLoading', false)

    return Promise.reject(error);
  });
